import React from 'react'

const Hotel2 = () => {
  return (
    <div>Hotel2</div>
  )
}

export default Hotel2